import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from 'app/app.component';
import { appConfig } from 'app/app.config';
import { initializeApp } from 'firebase/app';
import { getMessaging, isSupported } from 'firebase/messaging';

const firebaseConfig = {
    apiKey: "AIzaSyB2Gmb5IJpeKQ1jlpe52lRVY_bo18RKA28",
    authDomain: "phoenixcrm-998ec.firebaseapp.com/",
    projectId: "phoenixcrm-998ec",
    storageBucket: "phoenixcrm-998ec.firebasestorage.app",
    messagingSenderId: "947599122470",
    appId: "1:947599122470:web:eae5197c19cd57b49c86e7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

async function setupFcm(): Promise<void> {
    if (!('serviceWorker' in navigator)) return;
    if (!window.isSecureContext) {
        console.info('FCM disabled: requires HTTPS or localhost.');
        return;
    }

    const supported = await isSupported().catch(() => false);
    if (!supported) {
        console.info('FCM disabled: browser does not support required APIs.');
        return;
    }

    await navigator.serviceWorker.register('/firebase-messaging-sw.js');
    getMessaging(app);
}

if (typeof window !== 'undefined') {
    void setupFcm();
}

bootstrapApplication(AppComponent, appConfig).catch((err) =>
    console.error(err)
);
